import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import "./Referrals.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";
const Referrals = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Referrals
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="Genral-main-container text-center py-5" style={{maxWidth:"95%"}}>
        <div
          className="referrals-summary-inline"
          style={{
            // background: "#ededed",
            marginTop: "80px",
            // borderLeft: "5px solid #03b1ed",
            color:"black",
            // padding: "5px 20px 0px",
            textAlign: "start",
            // alignItems:"center",
            // justifyContent:"center",
            marginBottom: "120px",
            fontSize: "19px",
            // maxWidth:"90%",
            margin:"0 60px",
            
          }}
        >
          <p>
            If you would like a private dermatology appointment with Dr Ahmed
            you can either self-refer or ask your GP for a referral.
            <br />
            <br />
            Obtaining a GP referral is advisable if you have a private insurance
            as this is often the policy requirement.
            <br />
            <br />
            You can be often seen for a private consultation within days of
            calling for an appointment. You will always see Dr Ahmed as your
            Dermatologist. Your surgical procedure will be also carried out by
            Dr Ahmed.
            <br />
            <br />
            However Dr Ahmed is happy to see patients without a GP referral.
          </p>
        </div>
      </div>
      <div className="footer-import ">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default Referrals;
